import { render } from "./mobile_menu_upgrade.vue?vue&type=template&id=318ef126&scoped=true"
import script from "./mobile_menu_upgrade.vue?vue&type=script&lang=js"
export * from "./mobile_menu_upgrade.vue?vue&type=script&lang=js"

import "./mobile_menu_upgrade.vue?vue&type=style&index=0&id=318ef126&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./mobile_menu_upgrade.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-318ef126"]])

export default __exports__